// extracted by mini-css-extract-plugin
export default {"content":"AttachmentsPage_content__Yz1uw","isSubPage":"AttachmentsPage_isSubPage__-N4Ua","sections":"AttachmentsPage_sections__Gvajm","section":"AttachmentsPage_section__r-Svp"};